export default __webpack_public_path__ + "static/media/bookmark-icon.e8db3399.svg";